import { render, staticRenderFns } from "./ProductEditSellPrice.vue?vue&type=template&id=a712a9b0"
import script from "./ProductEditSellPrice.vue?vue&type=script&lang=ts"
export * from "./ProductEditSellPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports